import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAllChannels } from "../../../../app/slices";

export const useIntegratedChannels = (channelTypes) => {
  const [integratedChannels, setIntegratedChannels] = useState([]);
  
  // Add a check to prevent accessing undefined properties
  const integratedChannelData = useSelector(selectAllChannels) || [];

  useEffect(() => {
    // Only process if both are valid
    if (!integratedChannelData || !Array.isArray(integratedChannelData) || integratedChannelData.length === 0 || !channelTypes || Object.keys(channelTypes).length === 0) {
      return;
    }

    const updatedIntegratedChannels = integratedChannelData
      .map((channel) => {
        if (!channel) return null;
        
        const channelSlug = channel?.platformName?.toLowerCase() || "";
        const channelType = channelTypes[channelSlug];

        if (channelType) {
          const formFields = channelType.formFields.map((field) => ({
            ...field,
            value:
              channel?.platformSpecific?.[channelSlug]?.[field.name] || "",
          }));

          const storeName = channel?.platformSpecific?.[channelSlug]?.storeName || "";

          return {
            ...channelType,
            id: channel?._id || "", // Unique ID for each instance
            isIntegrated: channel?.isActive || false,
            formFields,
            storeName,
          };
        }
        return null;
      })
      .filter(Boolean);

    setIntegratedChannels(updatedIntegratedChannels);
  }, [integratedChannelData, channelTypes]);

  return [integratedChannels, setIntegratedChannels];
};